'use client';

import Box from '@enlighten/design-system/dist/Box';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import Image from 'next/image';
import React from 'react';
import Slider from 'react-slick';

import Img9001Mobile from '@/assets/images/pages/home/banners/img_9001_mobile.png';
import Img9001Web from '@/assets/images/pages/home/banners/img_9001_web.png';
import Img14001Mobile from '@/assets/images/pages/home/banners/img_14001_mobile.png';
import Img14001Web from '@/assets/images/pages/home/banners/img_14001_web.png';
import Img45001Mobile from '@/assets/images/pages/home/banners/img_45001_mobile.png';
import Img45001Web from '@/assets/images/pages/home/banners/img_45001_web.png';

const BANNERS = [
	{
		desktop: Img45001Web,
		mobile: Img45001Mobile,
		title: '안전보건경영시스템\n(ISO 45001) 인증 기업',
		description: '발생할 수 있는 위험을 사전에 예방하여\n파트너사의 소중한 자산을 안전하게 보호해요.',
	},
	{
		desktop: Img9001Web,
		mobile: Img9001Mobile,
		title: '품질경영시스템\n(ISO 9001) 인증 기업',
		description: '설계·조달·시공(EPC)부터\n운영(O&M), 플랫폼까지 데이터 기반의\n표준 프로세스로 전문성을 입증해요.',
	},
	{
		desktop: Img14001Web,
		mobile: Img14001Mobile,
		title: '환경경영시스템\n(ISO 14001) 인증 기업',
		description: '설비 설치와 운영 단계의 환경적 영향을\n선제적으로 관리하며\n지속 가능한 에너지 전환을 지원해요.',
	},
];

export default function Banner() {
	const [sliderKey, setSliderKey] = React.useState(0);

	// viewport가 변경되면 slider 너비 재계산 (따로 옵션이 없고 자동으로 해주지 않음)
	React.useEffect(() => {
		let timeoutId: ReturnType<typeof setTimeout>;

		const handleResize = () => {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				setSliderKey((prev) => prev + 1);
			}, 300);
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
			clearTimeout(timeoutId);
		};
	}, []);

	return (
		<Stack justifyContent="center" bgcolor="#202F48" position="relative">
			<Box
				display={{ xs: 'none', md: 'block' }}
				maxWidth="1440px"
				width="100%"
				margin="0 auto"
				sx={{
					'.slick-dots': {
						display: 'flex!important',
						flexDirection: 'column',
						position: 'absolute',
						right: '20px',
						top: 'calc(50% - 25px)',
						width: 'auto',

						'li button:before': {
							fontSize: 12,
							color: '#EEEEEE',
						},
					},
				}}
			>
				<Slider key={`desktop-${sliderKey}`} arrows={false} swipe={false} waitForAnimate={false} autoplaySpeed={2000} vertical autoplay dots>
					{BANNERS.map((item, index) => (
						<Box key={index} display="flex !important" gap="24px" height="340px" position="relative" padding="0 24px">
							<Stack justifyContent="center" flex={1} gap="8px">
								<Typography
									sx={{
										color: 'white',
										fontWeight: 700,
										fontSize: '34px',
										lineHeight: '44px',
										letterSpacing: '-1px',
									}}
								>
									{item.title}
								</Typography>
								<Typography
									variant="body1"
									sx={{
										color: 'white',
										fontSize: '18px',
										lineHeight: '26px',
										letterSpacing: '-0.7px',
									}}
								>
									{item.description}
								</Typography>
							</Stack>
							<Box position="relative" maxWidth="448px" width="100%" maxHeight="340px" height="100%" overflow="hidden">
								<Image src={item.desktop} alt={item.title} fill style={{ objectFit: 'contain', objectPosition: 'center' }} />
							</Box>
						</Box>
					))}
				</Slider>
			</Box>

			<Box
				display={{ xs: 'block', md: 'none' }}
				width="100%"
				sx={{
					'.slick-list': {
						margin: { xs: '0 -20px', md: '0 -24px' },
					},
					'.slick-slide > div': {
						padding: { xs: '0 10px', md: '0 12px' },
					},
					'.slick-dots': {
						bottom: '-30px',

						'li button:before': {
							fontSize: 12,
						},
					},
				}}
			>
				<Slider key={`mobile-${sliderKey}`} arrows={false} swipe={false} waitForAnimate={false} autoplaySpeed={2000} autoplay dots>
					{BANNERS.map((item, index) => (
						<Box key={index} display="flex !important" justifyContent="center" flexDirection="column" alignItems="flex-start" width="100%">
							<Stack flex="1 1 194px" gap="4px" padding="48px 24px 0">
								<Typography
									sx={{
										color: 'white',
										fontWeight: 700,
										fontSize: '24px',
										lineHeight: '32px',
										whiteSpace: 'pre-line',
									}}
								>
									{item.title}
								</Typography>
								<Typography
									variant="body1"
									sx={{
										color: 'white',
										lineHeight: '26px',
										whiteSpace: 'pre-line',
									}}
								>
									{item.description}
								</Typography>
							</Stack>
							<Image src={item.mobile} alt={item.title} style={{ objectFit: 'contain', width: '100%', height: '100%' }} />
						</Box>
					))}
				</Slider>
			</Box>
		</Stack>
	);
}
